import { LoginScreen } from "@home-health-notify/auth/web";
import { DomainContext, useTranslation } from "hhn-commons";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";

import logo from "../../assets/images/logo-without-notify.png";
import { ROUTES } from "../../routes";

/**
 * Web app's login route. The actual UI lives in @home-health-notify/auth/web.
 * We pass the host app's branding (logo + company name) as props.
 *
 * Theming (button color, radius, etc.) is handled via CSS variable overrides
 * — see src/index.css for the `.hhn-auth-screen` selector.
 */
function Login() {
  const { t } = useTranslation();
  const { domain } = useContext(DomainContext);
  const navigate = useNavigate();

  // Once the domain transitions to Authenticated (covers all paths to a
  // logged-in state while sitting on this route — boot probe with saved
  // cookies, SSO callback, and cross-app login detected via the auth
  // package's visibilitychange listener), navigate off /login. Otherwise
  // we'd sit on the sign-in screen showing a button that's already obsolete
  // — and clicking it produces Amplify's "already signed in" error.
  useEffect(() => {
    if (domain.domainType === "authenticated") {
      navigate(ROUTES.ORGANIZATIONS, { replace: true });
    }
  }, [domain, navigate]);

  return <LoginScreen logoSrc={logo} companyName={t("companyName")} />;
}

export default Login;
